export class TimeoutError extends Error {
    constructor(request) {
        super(`Request timed out: ${request.method} ${request.url}`);
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = 'TimeoutError';
        this.request = request;
    }
}
//# sourceMappingURL=TimeoutError.js.map